module.exports = __webpack_public_path__ + "1304c295b526502a0631d622e2bfd764.jpg";